export const providerDataKeyNames = {
  id: 'ID',
  cifNif: 'CIF/NIF',
  name: 'Nombre empresa',
  corporateName: 'Razón Social',
  chain: 'Cadena',

  address: 'Dirección',
  city: 'Ciudad',
  postalCode: 'Cód. postal',
  idCountry: 'ID país',
  idProvince: 'ID provincia',

  contactPerson: 'Persona de contacto',
  phone1: 'Teléfono',
  phone2: 'Móvil',
  email1: 'Email pedidos',
  email2: 'Email pedidos',
  email3: 'Email comercial',
  email4: 'Email financiero',

  buyerId: 'ID comprador',
  buyerName: 'Nombre comprador',

  ediInterlocutor: 'Interlocutor EDI',

  storage: 'Almacén',
  deliveryPlace: 'Lugar de entrega',
  transportMethod: 'Método de transporte',
  orderSendingMethod: 'Método de envío de pedido',
  carrier: 'Transportista',
  desadvReception: 'Recepción con DESADV',

  paymentAddress: 'Dirección de pago',
  paymentCity: 'Ciudad de pago',
  paymentPostalCode: 'Código postal de pago',
  idPaymentProvince: 'ID provincia pago',
  idPaymentCountry: 'ID país de pago',
  paymentPhone1: 'Teléfono 1 de pago',
  paymentPhone2: 'Teléfono 2 de pago',
  paymentEmail: 'Email de pago',

  sanitaryRegistry: 'Registro sanitario',
  ecologicCertificate: 'Certificado ecológico',
  traceabilityTemplate: 'Plantilla de trazabilidad'
}

export const providerRequiredField = {
  cifNif: '',
  name: '',
  email1: ''
}
